import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavbarIconsModuleConfigurations from "../generic-nav-bar/NavbarIconsModuleConfigurations";
import { moduleConfigurationClean, moduleConfigurationStartUpdate } from "../../app/actions/moduleConfigurationActions";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { SANITIZE_MODES } from "../../app/helpers/sanitizeModeHelper";
import { schemaValidateModuleConfigurationsList } from "../../app/data/schemaValidateModuleConfigurationsList";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import ViewLabel from "../generic-component/ViewLabel";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import NewCatalogRelationGenericField from "../generic-component/NewCatalogRelationGenericField";
import NewCatalogRelationGenericMenu from "../generic-component/NewCatalogRelationGenericMenu";
import NewRadioButtonGeneric from "../generic-component/NewRadioButtonGeneric";

const ID_FORM = "admin-module-configuration";
const OPERATION = "edit";

const EditModuleConfigurations = () => {
  debugLogPages(':: EditModuleConfigurations');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { moduleConfiguration, moduleConfigurations } = useSelector((state) => state.moduleConfig);

  const { catalogModules } = useSelector((state) => state.catalogModule);

  const { catalogRoles } = useSelector((state) => state.catalogRole);

  const { listDataTypes, listTypeFields, listComponentNew, listComponentView,
    listCatalogModules, listRelationComparable, listStyleTable
   } = useSelector((state) => state.catalog);

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation, handleChangeSingleCatalog, handleChangeRadioButton } = useFormValidationsGeneric(
      () => moduleConfigurationCallback(),
      moduleConfiguration,
      schemaValidateModuleConfigurationsList
    );

  useEffect(() => {
          
          if (values) {
            
            handleChange(getObjectByName(values.data_type, listDataTypes), "data_type");
  
            handleChange(getObjectByName(values.type, listTypeFields), "type");
            handleChange(getObjectByName(values.component_new, listComponentNew), "component_new");
            handleChange(getObjectByName(values.component_view, listComponentView), "component_view");
            handleChange(getObjectByName(values.module_text, listCatalogModules), "module_text");
            handleChange(getObjectByName(values.comparable_relation_condition, listRelationComparable), "comparable_relation_condition");
            handleChange(getObjectByName(values.style_in_table, listStyleTable), "style_in_table");
            handleChange(getObjectByName(values.sanitize_mode, SANITIZE_MODES), "sanitize_mode");

            handleChange(getObjectById(values.catalogmodule_id, catalogModules), "catalogmodule_id");

          }
      
        }, [listDataTypes,listTypeFields, listComponentNew, listComponentView,
          listCatalogModules, listRelationComparable, listStyleTable, catalogModules])

        const getObjectById = (id, arraySearch) => {
          const elementFound = arraySearch.find((ser) => ser.id === id);
          return elementFound;
        };

        const getObjectByName = (name, arraySearch) => {
          const elementFound = arraySearch.find((ser) => ser.name === name);
          return elementFound;
        };
      
        const getMethodData = (currentData) => {
          let comboData = [];
          let level = 0;
      
          if (currentData === "parent_id") {
            comboData = moduleConfigurations;
            level = 1;
          }else if (currentData === "catalogmodule_id") {
            comboData = catalogModules;
            level = 1;
          }else if (currentData === "catalogrole_id") {
            comboData = catalogRoles;
            level = 1;
          }
  
          else if (currentData === "data_type") {
            comboData = listDataTypes;
            level = 1;
          }
          else if (currentData === "type") {
            comboData = listTypeFields;
            level = 1;
          }
          else if (currentData === "component_new") {
            comboData = listComponentNew;
            level = 1;
          }
          else if (currentData === "component_view") {
            comboData = listComponentView;
            level = 1;
          }
          else if (currentData === "module_text") {
            comboData = listCatalogModules;
            level = 1;
          }
          else if (currentData === "comparable_relation_condition") {
            comboData = listRelationComparable;
            level = 1;
          }
          else if (currentData === "style_in_table") {
            comboData = listStyleTable;
            level = 1;
          }
          else if (currentData === "sanitize_mode") {
            comboData = SANITIZE_MODES;
            level = 1;
          }
  
          return { comboData, level };
        };

  function moduleConfigurationCallback() {
    debugLogPages(':: EditModuleConfigurations, moduleConfigurationCallback, values', {values}); 

    let valuesSubmit = { ...values };
    valuesSubmit.deleted = false;

     debugLogPages(':: EditModuleConfigurations, moduleConfigurationCallback, valuesSubmit', {valuesSubmit});
    dispatch(moduleConfigurationStartUpdate(valuesSubmit, navigate));

    dispatch(moduleConfigurationClean());
  }

  debugLogPages(':: EditModuleConfigurations', {errors}); 
  debugLogPages(':: EditModuleConfigurations', {values}); 

  debugLogPages(':: EditModuleConfigurations', {listDataTypes}); 
  debugLogPages(':: EditModuleConfigurations', {listTypeFields}); 
  debugLogPages(':: EditModuleConfigurations', {listComponentNew}); 
  debugLogPages(':: EditModuleConfigurations', {listComponentView}); 
  debugLogPages(':: EditModuleConfigurations', {listCatalogModules}); 
  debugLogPages(':: EditModuleConfigurations', {listStyleTable}); 

  return (
    <div>
      <NavbarIconsModuleConfigurations page={"editModuleConfigurations"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateModuleConfigurationsList && schemaValidateModuleConfigurationsList.length > 0 && (
                  schemaValidateModuleConfigurationsList.map((techSecondary, index) => {
                    
                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData, level } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGenericField") {
                      return (
                        <NewCatalogRelationGenericField
                          key={techSecondary.id}
                          handleChange={handleChangeSingleCatalog}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                          level={level}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGenericMenu") {
                      return (
                        <NewCatalogRelationGenericMenu
                          key={techSecondary.id}
                          handleChange={handleChangeSingleCatalog}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                          level={level}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric1") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewRadioButtonGeneric") {
                      return (
                        <NewRadioButtonGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeRadioButton}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      )
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EditModuleConfigurations;
